import React, { useCallback, useMemo, useEffect, useRef, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import {
  Box,
  Button,
  IconButton,
  Typography,
  Tooltip,
  TextField
} from '@mui/material';

import { Row, Col, Modal } from "react-bootstrap";
import CsvDownloadButton from 'react-json-to-csv'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import { Delete, Print, Download, List, Edit } from '@mui/icons-material';
import { useNavigate, Link, useParams, useSearchParams } from "react-router-dom";
import * as AuthVerify from '../../lib/common';

const CustomTable = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dmShow, setDmShow] = useState(false);
  const selectedMatnum = useRef(false);

  const [logedIn, setLogedIn] = useState(false);
  const [editPermission, setEditPermission] = useState(false);
  const [deletePermission, setDeletePermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const [addNewPermission, setAddNewPermission] = useState(false);

  const [columnFilters, setColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    ctrname: 'contains',
    ctrnum: 'contains',
    startdate: 'contains',
    enddate: 'contains'
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });

  useEffect(() => {
    setLogedIn(AuthVerify.isUserLogedIn());
    const permission =AuthVerify.getPermissions("MyContracts");
    setViewPermission(permission?.view);
    setEditPermission(permission?.edit);
    setDeletePermission(permission?.delete);
    setAddNewPermission(permission?.addnew);
    // fetchDataFromAPI()
}, []);
 

  const handleDeleteRow = useCallback(
    (row) => {
      setDmShow(false);
      if (!row) row = selectedMatnum.current;
      if (!row) return;
      deleteHandler();
    },
    [data],
  );

  const findFilterCondition = (name) => {
    var condition = '';
    if (columnFilterFns[name]) {
      condition = columnFilterFns[name];
    }
    // if(condition==''){
    //   condition = initialColumnFiltersFns[name];
    // }
    return condition;
  }

  const fetchDataFromAPI = async (reset = false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }

    let filterQuery = '';
    let sorterQuery = '';

    if (!reset) {
      if (columnFilters.length > 0) {
        columnFilters.forEach(element => {
          if(element.id === 'startdate' || element.id === 'enddate'){
            filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${AuthVerify.getDate(element.value)}`;
          }
          else{
            filterQuery += `&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
          }
        });
      }
      if (sorting.length > 0) {
        sorting.forEach(element => {
          sorterQuery += `&sortby=${element.id}&orderby=${element.desc ? 'desc' : 'asc'}`;
        });
      }
    } else {
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }

    // Get Contract List
    let url = `/corporate/contract?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data.users.items??[]);
          setRowCount(response.data?.data.users.count);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };


  useEffect(() => {
    fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting
  ]);

  const deleteHandler = async () => {
    setIsLoading(true);
    const arnum = AuthVerify.getUser().arnum;
    const catalognum = searchParams.get("catalognum")
    await Axios.delete(`/corporate/user/${arnum}/${catalognum}/${selectedMatnum.current}`)
      .then(function (response) {
        setIsLoading(false);
        setIsError(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data.items ?? []);
          setRowCount(response.data?.data.items.length);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        // navigate('/');
      });
  }

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => row.ctrname,
        id: 'ctrname',
        header: 'Contract Name',
        enableEditing: false,
        size: 50,
        Cell: ({ cell, row }) => (
          <Typography variant='h5'>{cell.getValue()}</Typography>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'ctrnum',
        header: "Contract #",
        Cell: ({ cell, row }) => (
            <Typography variant='h5'>{cell.getValue()}</Typography>
        ),
        size: 50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'startdate',
        header: "Start Date",
        Cell: ({ cell, row }) => (
          <Typography variant='h5'>{cell.getValue()}</Typography>
        ),
        size: 50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
        Filter: ({ column, header, table }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <input
              type="date"
              style={{margin:'6px 10px 3px 0',border:'1px solid #ddd',padding:'4px 0',color:'#777',fontSize:'13px'}}
              onChange={(newValue) => {
                column.setFilterValue(newValue.target.value);
              }}
              value={column.getFilterValue()}
            />
            <hr style={{margin:'0px',borderColor:'black'}}/>
            <p style={{color:'rgba(0, 0, 0, 0.6)',fontSize:'12px'}}>Filter Mode: contains</p>
          </LocalizationProvider>
          
        ),
      },
      {
        accessorKey: 'enddate',
        header: "End Date",
        Cell: ({ cell, row }) => (
          <Typography variant='h5'>{cell.getValue()}</Typography>
        ),
        size: 50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
        Filter: ({ column }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <input
              type="date"
              style={{margin:'6px 10px 3px 0',border:'1px solid #ddd',padding:'4px 0',color:'#777',fontSize:'13px'}}
              onChange={(newValue) => {
                column.setFilterValue(newValue.target.value);
              }}
              value={column.getFilterValue()}
            />
            <hr style={{margin:'0px',borderColor:'black'}}/>
            <p style={{color:'rgba(0, 0, 0, 0.6)',fontSize:'12px'}}>Filter Mode: contains</p>
          </LocalizationProvider>
        ),
      }
      //end
    ],
    [],
  );
  
  return (
    <>
      
      <MaterialReactTable
        columns={columns}
        data={data}
        enableColumnActions={false}
        enableGlobalFilter={false}
        enableColumnFilterModes
        initialState={{
          showColumnFilters: false
        }}
        manualFiltering
        manualPagination
        manualSorting
        onColumnFilterFnsChange={setColumnFilterFns}
        onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        onPaginationChange={setPagination}
        onSortingChange={setSorting}
        tableInstanceRef={tableInstanceRef}
        rowCount={rowCount}
        enableEditing
        state={{
          columnFilters,
          columnFilterFns,
          globalFilter,
          isLoading,
          pagination,
          showAlertBanner: isError,
          showProgressBars: isRefetching,
          sorting,
        }}
        positionActionsColumn="last"
        displayColumnDefOptions={{
          'mrt-row-actions': {
            header: 'Action', //change header text
          },
        }}
        renderRowActions={({ row, table }) => (
          <Box sx={{ display: 'flex', gap: '1rem' }}>
            {viewPermission &&
            <Tooltip arrow placement="left" title="Details">
              <IconButton onClick={() => navigate(`/contract-details?ctrnum=${row.original.ctrnum}`)}>
                <List />
              </IconButton>
            </Tooltip>
            }
            {editPermission &&
              <Tooltip arrow placement="right" title="Edit">
                <IconButton color="success" onClick={() => navigate(`contract-details?ctrnum=${row.original.ctrnum}`)}>
                  <Edit />
                </IconButton>
              </Tooltip>}
              {deletePermission &&
              <Tooltip arrow placement="right" title="delete">
                <IconButton color="success" onClick={() => navigate(`contract-details?ctrnum=${row.original.ctrnum}`)}>
                  <Delete />
                </IconButton>
              </Tooltip>}
          </Box>
        )}
        muiTableHeadCellProps={{
          sx: {
            // fontWeight: 'bold',
            fontSize: '15px',
          },
        }}
        muiTablePaginationProps={{
          sx: {
            fontWeight: 'bold',
            paddingTop: '12px',
            fontSize: '16px',
          },
        }}
        muiTableBodyCellEditTextFieldProps={({ cell, column, row, table }) => ({
          sx: {
            fontSize: '16px'
          },
        })}
        muiTableHeadCellFilterTextFieldProps={{
          sx: {
            fontWeight: 'bold',
            fontSize: '17px',
          },
        }}
      />

        <Modal show={dmShow} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setDmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure about the delete ?
        </Modal.Body>
        <Modal.Footer>
          <button
            className="button btn-primary"
            title="Proceed to Checkout"
            type="button"
            onClick={() => handleDeleteRow()}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Confirm</span>
          </button>
          <button
            className="button btn-danger"
            title="Proceed to Checkout"
            type="button"
            onClick={() => setDmShow(false)}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Close</span>
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomTable;
